import { render, staticRenderFns } from "./TableButtons.vue?vue&type=template&id=1505e06c&"
import script from "./TableButtons.vue?vue&type=script&lang=js&"
export * from "./TableButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1505e06c', component.options)
    } else {
      api.reload('1505e06c', component.options)
    }
    module.hot.accept("./TableButtons.vue?vue&type=template&id=1505e06c&", function () {
      api.rerender('1505e06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Table/TableButtons.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Table/TableButtons.vue
// module id = EjA6
// module chunks = 0